//React
import { useState, useEffect, Fragment } from "react";

//Chakra
import {
  SimpleGrid,
  VStack,
  Box,
  Text,
  Flex,
  Button,
  Center,
  Textarea,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Select,
} from "@chakra-ui/react";

//Custom Component
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody.js";
import { useAppToast } from "utils/toastUtil";

//Endpoint
import { updatePublishStatus } from "service/publish.service";
import CardBadge from "components/Card/CardBadge.js";
import moment from "moment";

//Package
const {
  useHistory,
  useLocation,
  useParams,
} = require("react-router-dom/cjs/react-router-dom.min");
import { useFormik } from "formik";
import * as yup from "yup";
import { PUBLISH_ACTION_COLOR } from "constants";

export default function publishDetail() {
  // variable
  const history = useHistory();
  const location = useLocation();
  const route_param = useParams();
  const { showToast } = useAppToast();

  const [publishes, setPublishes] = useState(location?.state ?? null);
  const [loading, setIsLoading] = useState(false);

  //methods

  const getOrder = async (route_param) => {
    try {
      // const specificOrder = await getOrderDetails(route_param);
      // if (specificOrder) {
      // setPublishes(specificOrder.data.data);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      publish_id: publishes.id,
      message: publishes.message ?? "",
      status: publishes.status ?? "pending",
    },
    validationSchema: yup.object().shape({
      message: yup.string().required("required"),
      status: yup.string().required("required"),
    }),
    onSubmit: async (values) => {
      try {

        values.status == 'inactive' ? values.status = 'deactivate' : values.status = 'activate';

        const res = await updatePublishStatus(values);
        if(res)
        {
          showToast({
            title: "Success",
            description: "Updated publish status",
            status: "success",
          });
          setIsLoading(true)
          history.push("/admin/publish");
        }
        
      } catch (error) {
        console.log(error)
        formik.setErrors({ ...error });
      }
    },
  });
  //
  //setup
  useEffect(() => {
    if (publishes === null) history.push("/admin/publish");
  }, []);

  //component

  // console.log(publishes);
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <>
        <Card my={"4"}>
          <CardHeader p="6px 0px 22px 0px">
            <Text
              fontSize="lg"
              color="#fff"
              fontWeight="bold"
              textColor={"limegreen"}
              textTransform={"uppercase"}
            >
              Resource Detail
            </Text>
          </CardHeader>
          <CardBody w={"full"}>
            <SimpleGrid columns={2} w={"full"}>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Type</Text>
                <CardBadge props={publishes?.publishable_type} />
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Name</Text>
                <CardBadge
                  props={
                    publishes?.publishable_type == "job"
                      ? publishes?.publishable?.title
                      : publishes?.publishable?.name
                  }
                />
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Description</Text>
                <CardBadge props={publishes?.publishable?.description} />
              </VStack>
            </SimpleGrid>
          </CardBody>
        </Card>
        <Card my={"4"}>
          <CardHeader p="6px 0px 22px 0px">
            <Text
              fontSize="lg"
              color="#fff"
              fontWeight="bold"
              textColor={"mediumpurple"}
              textTransform={"uppercase"}
            >
              Resource Owner
            </Text>
          </CardHeader>
          <CardBody w={"full"}>
            <SimpleGrid columns={2} w={"full"}>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Username</Text>
                <CardBadge
                  props={
                    publishes?.publishable_type == "job"
                      ? publishes?.publishable?.user?.username
                      : publishes?.publishable?.professional_profile?.user?.username
                  }
                />
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Full Name</Text>
                <CardBadge
                  props={
                    publishes?.publishable_type == "job"
                      ? publishes?.publishable?.user?.profile?.full_name
                      : publishes?.publishable?.professional_profile?.user?.profile
                          ?.full_name
                  }
                />
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Gigger Name</Text>
                <CardBadge
                  props={publishes?.publishable?.professional_profile?.nickname}
                />
              </VStack>
              {/* <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Nickname</Text>
                <CardBadge props={publishes?.publishable_type} />
              </VStack> */}
            </SimpleGrid>
          </CardBody>
        </Card>
        <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
          <CardHeader p="6px 0px 22px 0px">
            <Text
              fontSize="lg"
              color="#fff"
              fontWeight="bold"
              textColor={"cyan.300"}
              textTransform={"uppercase"}
            >
              Publish Detail
            </Text>
          </CardHeader>
          <CardBody w={"full"}>
            <Box w={"full"}>
              <SimpleGrid columns={2} w={"full"}>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Status</Text>
                  <Select
                    color="white"
                    bg={PUBLISH_ACTION_COLOR[formik.values.status]}
                    border="transparent"
                    borderRadius="20px"
                    fontSize="sm"
                    size="lg"
                    w={{ base: "100%", md: "346px" }}
                    maxW="100%"
                    h="46px"
                    placeholder="Update Status"
                    {...formik.getFieldProps("status")}
                  >
                    <option value={"pending"}>Pending</option>
                    <option value={"active"}>ACTIVATE</option>
                    <option value={"inactive"}>DEACTIVATE</option>
                  </Select>
                </VStack>
              </SimpleGrid>
              <FormControl isInvalid={formik.errors.message && formik.touched.message}>
                <FormLabel color={"white"}>Message</FormLabel>
                <Textarea
                  bgColor={"gray.600"}
                  color={"white"}
                  {...formik.getFieldProps("message")}
                />
                <FormErrorMessage>{formik.errors.message}</FormErrorMessage>
              </FormControl>
            </Box>
          </CardBody>
        </Card>
        <Center>
          <Button
            isDisabled={false}
            variant="brand"
            fontSize="10px"
            type="submit"
            w="100%"
            maxW="350px"
            h="45"
            mb="20px"
            mt="20px"
            mx={"2"}
            textTransform={"uppercase"}
            fontWeight={"bold"}
            backgroundColor={"green.500"}
            onClick={() => {
              setIsLoading(false)
              formik.submitForm()
            }}
          >
            Update Status
          </Button>
        </Center>
      </>
    </Flex>
  );
}
